import { render, staticRenderFns } from "./ChatPopup.vue?vue&type=template&id=7afb0f23&scoped=true&"
import script from "./ChatPopup.vue?vue&type=script&lang=js&"
export * from "./ChatPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChatPopup.vue?vue&type=style&index=0&id=7afb0f23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afb0f23",
  null
  
)

export default component.exports